import {
  ApolloClient,
  ApolloLink,
  createHttpLink,
  InMemoryCache,
} from '@apollo/client'
import { API_ROOT, APP_VERSION } from 'env'
import { getToken } from './token'

const defaultOptions = {
  watchQuery: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'ignore',
  },
  query: {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all',
  },
}

const achievementsHttpLink = createHttpLink({
  uri: operation => `${API_ROOT}/graphql?op=${operation.operationName}`,
})

const achievementsAuthLink = new ApolloLink((operation, forward) => {
  const { skipAuth } = operation.getContext()
  const token = !skipAuth && getToken()

  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      ...(token && { authorization: `Bearer ${token}` }),
      'X-Client-Version': APP_VERSION,
      'X-Client-Name': 'achievements-portal',
    },
  }))
  return forward(operation)
})

export const achievementsLink = achievementsAuthLink.concat(
  achievementsHttpLink,
)

export const achievementsApolloClient = new ApolloClient({
  link: achievementsLink,
  cache: new InMemoryCache({ resultCaching: false }),
  defaultOptions,
})

export default achievementsApolloClient
